// Unpublished Work © 2021 Deere & Company

export const CriticalCustomerNameValues = [
    'firstName',
    'lastName',
    'middleName',
    'generation',
    'businessName1',
    'businessName2'
];
